import cloneDeep from 'lodash/cloneDeep';

import type { License } from './license';
import { initialLicense } from './license';
import type { Profile } from './profile';
import { initialProfile } from './profile';

export interface ProfileState {
    fetch: boolean;
    fetchErrorMessage: string;
    fetchError: string;
    fetchSuccess: string;
    profileLoading: boolean;
    profile: Profile;
    license: License;
    authSuccess: boolean;
    pageFetch: boolean;
}

export const initialState: ProfileState = {
    fetch: false,
    fetchErrorMessage: null,
    fetchError: null,
    fetchSuccess: null,
    profileLoading: true,
    profile: cloneDeep(initialProfile),
    license: cloneDeep(initialLicense),
    authSuccess: false,
    pageFetch: false,
};
